import React from 'react';
import styled from 'styled-components';

import { FONT } from '../../styles/color';

const NavigationWrapper = styled.div`
	width: 515px;
	height:35px;
	display:flex;
	flex-direction:row;
	justify-content:center;
	gap: 5px;
`;

const PagesWrapper = styled.div`
	width: 355px;
	height: 35px;
	display: flex;
	flex-direction: row;
	justify-content: center;
	gap: 5px;
`;

const PageButton = styled.button`
	width: 35px;
	height: 35px;
	margin: 0;
	background-color: ${ (props) => props.$isSelected ? FONT.default : 'transparent' };
	border: none;
	border-radius: 5px;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	font: 650 16px Pretendard Variable;
	color: ${ (props) => props.$isSelected ? FONT.light01 : FONT.default };
`;

export default function PageNavigation(props) {
	let startPage, endPage;

	if (props.totalPage <= 9) {
		startPage = 1;
		endPage = props.totalPage;

		if(endPage < 1) endPage = 1;
	} else {
		startPage = Math.max(1, props.currentPage - 4);
		endPage = Math.min(props.totalPage, props.currentPage + 4);
		
		// 시작이 1이면 끝을 9로 조정
		if (startPage === 1) {
			endPage = 9;
		}
		// 끝이 totalPage면 시작을 조정
		else if (endPage === props.totalPage) {
			startPage = props.totalPage - 8;
		}
	}

	const pages = Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index);
	
	return (
		<NavigationWrapper style={props.style}>
			<PageButton onClick={() => props.onPageChange(1)}>{"<<"}</PageButton>
			<PageButton onClick={() => props.onPageChange(props.currentPage - 1)}>{"<"}</PageButton>
			{
				<PagesWrapper>
					{
						pages.map((page) => (
							<PageButton
								key={page}
								onClick={() => props.onPageChange(page)}
								$isSelected={page === props.currentPage}
							>
								{page}
							</PageButton>
						))
					}
				</PagesWrapper>
			}
			<PageButton onClick={() => props.onPageChange(props.currentPage + 1)}>{">"}</PageButton>
			<PageButton onClick={() => props.onPageChange(props.totalPage)}>{">>"}</PageButton>
		</NavigationWrapper>
  	);
}
